import { Pipe, PipeTransform } from '@angular/core';
/*
 * Dada una key pasada como argumento, retorna una
 * representacion legible.
 * Toma como argumento un string.
 *
 * Uso:
 *   key | humanize
 *
 * Ejemplo:
 *
 *   {{ 'TABLA_SIMPLE' | humanize }}
 *
 *   retorna: 'Tabla Simple'
*/
@Pipe({ name: 'DocumentTypePipe' })
export class DocumentTypesPipe implements PipeTransform {

    constructor() {
    }

    transform(key: string): string {
        const mappingKeys = {
            'Policy': 'HUM_DOC_POLICY',
            'Customer': 'HUM_DOC_CUSTOMER',
            'Claim': 'HUM_DOC_CLAIM',
            'Unknown': 'HUM_DOC_UNKNOWN',
            'None': 'HUM_DOC_NONE',
        };
        return mappingKeys[key] || '';
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/pipes/documentTyper.pipe.ts